import { useStore } from 'effector-react'
import * as React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { $userRole, UserRole } from '../user'
import { path, role } from '../../libs'
import { setRedirectPath } from './model'

type Props = {
  children?: React.ReactNode
  allow?: UserRole
}

export const Protect = ({ children, allow = [] }: Props) => {
  const userRole = useStore($userRole)
  const location = useLocation()

  if (userRole) {
    if (userRole.includes(role.unauthorized())) {
      setRedirectPath(location.pathname) // Сохраняем исходный путь
      return <Navigate to={path.login.entry()} />
    }

    if (userRole.includes(role.logged())) {
      if (allow.some((role) => userRole.indexOf(role) >= 0)) {
        if (children) return <>{children}</>
        return <Navigate to={path.dashboard()} />
      }
    }
  }

  return <></>
}
